module.exports = __webpack_public_path__ + "static/media/29BDOS13.0bc7bfdf.jpg";